var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forDealers"},[_c('v-container',{attrs:{"grid-list-xs":"","pa-2":""}},[_c('h1',{staticClass:"display-1 primary--text"},[_vm._v(_vm._s(_vm.resx('forDealers')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }